import { render, staticRenderFns } from "./WeightsView.vue?vue&type=template&id=1b24c785&scoped=true"
import script from "./WeightsView.vue?vue&type=script&lang=js"
export * from "./WeightsView.vue?vue&type=script&lang=js"
import style0 from "./WeightsView.vue?vue&type=style&index=0&id=1b24c785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24c785",
  null
  
)

export default component.exports